import { api } from 'shared/api'

import { storeTemplateSchemas } from './schema'

export const StoreTemplateApi = {
  getStoreTemplate: api.base.createGet({
    url: '/templateStore/getTemplate',
    schemas: storeTemplateSchemas.getStoreTemplate,
  }),
  installStoreTemplate: api.base.createPost({
    url: '/templateStore/{template_id}/install',
    schemas: storeTemplateSchemas.installStoreTemplate,
  }),
}
